<template>
  <div
    class="in-stock"
    :class="badgeInfo.class"
  >
    <div class="in-stock__text-wrap">
      <img :src="badgeInfo.icon" alt="icon" />
      <span>{{ badgeInfo.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductInStock',
  computed: {
    ...mapState({
      inStock: state => state.productInfo.productInfo.inStock,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      price: state => state.productInfo.productInfo.price,
      // availableInStore: state => state.productInfo.productInfo.availableInStore,
      isOnlyOnSite: state => state.productInfo.productInfo.isOnlyOnSite,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isArchive: state => state.productInfo.productInfo.isArchive,
      productId: state => state.productInfo.productInfo.productId,
      arrivalDate: state => state.productInfo.productInfo.arrivalDate,
      productQuantityForEndsBadge: state => +state.productInfo.productInfo.productQuantityForEndsBadge,
      totalProductQuantity: state => state.productInfo.productInfo.totalProductQuantity,
      storesData: state => state.productInfo.productInfo.storesData,
      maxAvailableQuantity: state => state.productInfo.productInfo.maxAvailableQuantity
    }),
    availableInStore () {
      return !this.maxAvailableQuantity && this.storesData.find(el => +el.quantity > 0)
    },
    badgeInfo () {
      // Только на сайте
      if (this.isOnlyOnSite && this.price) {
        return {
          icon: '/img/svgo/product-page/only-on-site.svg',
          text: this.$t('product_available_only_on_site'),
          class: 'in-stock--only-on-site'
        }
      }
      // Только для самовывоза
      if (this.availableInStore && this.price) {
        return {
          icon: '/img/svgo/product-page/only-in-store.svg',
          text: this.$t('product_available_only_in_store'),
          class: 'in-stock--only-in-store'
        }
      }
      // Заканчивается, Есть в наличии
      if (this.inStock && this.price) {
        const isProductEnds = this.totalProductQuantity < this.productQuantityForEndsBadge
        return {
          icon: isProductEnds ? '/img/svgo/product-page/alarm.svg' : '/img/svgo/product-page/in-stock.svg',
          text: isProductEnds ? this.$t('product_ends') : this.$t('product.in.stock'),
          class: isProductEnds ? 'in-stock--ends' : ''
        }
      }
      if (this.isPreorder && !this.isArchive) {
        return {
          icon: '/img/svgo/product-page/plus-circle.svg',
          text: this.$t('pre_order_available'),
          class: 'in-stock--novelty'
        }
      }
      // Нет в наличии
      return {
        icon: '/img/svgo/product-page/not-in-stock.svg',
        text: this.$t('out.of.stock'),
        class: 'in-stock--false'
      }
    }
  }
}
</script>

<style scoped lang="sass">

.in-stock
  width: max-content
  padding: 8px 20px
  background: $nd-green-background-color
  color: $nd-green-text-color
  border-radius: 5px
  font-size: 13px
  line-height: 15px
  margin-bottom: 20px

  &--false, &--preorder
    background: $nd-gray-text-color
    color: rgba(51, 51, 51, 0.7)

  &--novelty
    background: $nd-yellow-background-color
    color: $nd-yellow-text-color

  &--ends
    background-color: rgba(255, 173, 50, 0.1)
    color: rgba(255, 47, 0, 0.8)

  &--only-on-site
    background: rgba(204, 204, 204, 0.1)
    color: $nd-link-color

  &--only-in-store
    background: #F3F3F3
    color: #333

  img
    margin-right: 10px

.in-stock__text-wrap
  display: flex
  align-items: center

</style>
